module.exports = __webpack_public_path__ + "img/board-82.ec4d3b1c.png";